import type { Relation } from '../model';

class CycleHelper {
  static findLoopRelationIds(
    entityIds: ReadonlyArray<number>,
    relations: ReadonlyArray<Relation>
  ): Set<string> {
    const outgoing = new Map<number, Relation[]>();
    const owned = new Set<number>();
    relations.forEach((relation) => {
      outgoing.set(relation.ownerId, [
        ...(outgoing.get(relation.ownerId) ?? []),
        relation,
      ]);
      owned.add(relation.ownedId);
    });
    outgoing.forEach((list) =>
      list.sort((a, b) => b.percent - a.percent || a.ownedId - b.ownedId)
    );

    const sorted = [...entityIds].sort((a, b) => a - b);
    const starts = [
      ...sorted.filter((id) => !owned.has(id)),
      ...sorted.filter((id) => owned.has(id)),
    ];
    const state = new Map<number, 'visiting' | 'done'>();
    const loops = new Set<string>();

    starts.forEach((start) => {
      if (state.has(start)) return;
      const stack: Array<{ id: number; next: number }> = [
        { id: start, next: 0 },
      ];
      state.set(start, 'visiting');
      while (stack.length > 0) {
        const top = stack[stack.length - 1];
        const edges = outgoing.get(top.id) ?? [];
        if (top.next >= edges.length) {
          state.set(top.id, 'done');
          stack.pop();
        } else {
          const relation = edges[top.next];
          top.next += 1;
          const targetState = state.get(relation.ownedId);
          if (targetState === 'visiting') loops.add(relation.id);
          if (targetState === undefined) {
            state.set(relation.ownedId, 'visiting');
            stack.push({ id: relation.ownedId, next: 0 });
          }
        }
      }
    });
    return loops;
  }
}

export { CycleHelper };
